module.exports = __webpack_public_path__ + "static/media/ubrand_sketch.5f7a9585.png";